import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { StoreService } from '../store.service';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';
import { MenuItem } from 'primeng/api';
import {AutoCompleteModule} from 'primeng/autocomplete';

@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.component.html',
  styleUrls: ['./vendor-list.component.css'], 
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService, ConfirmationService]
})
export class VendorListComponent implements OnInit {

  activeIndex: number = 0;
  steps: MenuItem[];
  qboVendAcctDefault: any = [];
  qboVendors: SelectItem[] = [];
  msgs: Message[] = [];
  loadingMessage:any = "Loading...";
  text: string;

    
      
  

  constructor(private router: Router, private api: ApiService, private spinner: NgxSpinnerService, private ss: StoreService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {

    this.bindVendAcctDefault();
    //this.bindSalesTax();
       
  }
  syncVendorFromRAH() {
    this.loadingMessage = "Sync All Vendor...";
    this.spinner.show();
    this.api.post('Rah/SyncAllVendor', "").subscribe(
      (res: {}) => this.succes_syncVendorFromRAH(res),
      error => this.failed_syncVendorFromRAH(<any>error));
  }
  
  succes_syncVendorFromRAH(resp: any) {
    this.spinner.hide();
    this.getVendor();
  }

  failed_syncVendorFromRAH(resp: any) {
    this.spinner.hide();
    this.msgs=[];
    this.msgs.push({ severity: 'error', summary: 'Failed', detail: 'Please reconnect your company & try again...' });

    this.getVendor();

  }

 

getVendor() {
  this.spinner.show();
  this.loadingMessage = "Get Vendor...";
  this.api.get('Rah/GetAllQboVendor', '').subscribe(
    (res: {}) => this.success_getVendor(res),
    error => this.failed_getVendor(<any>error));
}

success_getVendor(resp: any) {
  this.spinner.hide();
  this.ss.storeQboVendors(resp.Data);
  this.qboVendAcctDefault=resp.Data;
}

failed_getVendor(resp: any) {
  this.spinner.hide();
  this.msgs=[];
    this.msgs.push({ severity: 'error', summary: 'Failed', detail: 'Please reconnect your company & try again...' });

}

  bindVendAcctDefault() {


    this.spinner.show();
    this.loadingMessage = "Getting Suppliers..."

    this.api.get('Rah/GetAllQboVendor', '').subscribe(
      (res: {}) => this.sucessGetVendAcct(res),
      error => this.failedGetVendAcct(<any>error));
  }

  sucessGetVendAcct(resp: any) {
    this.spinner.hide();
    if(resp.Data!=null){
    this.qboVendAcctDefault = resp.Data;

    this.qboVendAcctDefault= this.qboVendAcctDefault.sort((a, b) => {
      return <any>new Date(b.AddedDate) - <any>new Date(a.AddedDate);
    });
  }else{
    this.msgs=[];
    this.msgs.push({ severity: 'error', summary: 'Failed', detail: 'Please reconnect your company & try again...' });

  }
  }

  failedGetVendAcct(resp: any) {
    this.spinner.hide();
  }


  validateAccount(resp: any)
  {
    this.msgs = [];
    this.spinner.hide();
  }
  
}
